<template>
  <div class="pepper-share-frame">
    <div class="frame">
      <pepper-celebration-internal class="internal" :first-name="firstName" :show-sun="true" :should-fade-in="false" />
    </div>
    <div class="tail">
      <div class="logo"><img src="@/assets/logo-vertical-yellow.svg"></div>
      <div class="site-url">riseup.co.il</div>
    </div>
  </div>
</template>
<script>

import PepperCelebrationInternal from './PepperCelebrationInternal';

export default {
  components: {
    PepperCelebrationInternal,
  },
  props: {
    firstName: { type: String, required: true },
  },
  name: 'PepperCelebrationSharable',
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.pepper-share-frame {
  display: flex;
  flex-direction: column;
  width: 400px;
  height: 660px;
  background: $riseup-white;
  padding: 8px;
  overflow: hidden;

  .frame {
    height: 660px;
    overflow: hidden;
    border-radius: 8px;
    background: #EB73EF;
  }

  .tail {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-end;
    justify-content: space-between;
    padding-top: 15px;
    background-color: $riseup-white;

    .logo img {
      height: 45px;
    }

    .site-url {
      font-family: SimplerPro;
      color: $riseup_black;
      font-size: 18px;
    }
  }
}
</style>
